import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import DataTable from '../../components/common/DataTable';
import { activityApi } from '../../api/activity.api';

export default function ActivityLogPage() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadAdmins();
  }, []);

  const loadAdmins = async () => {
    try {
      setLoading(true);
      const response = await activityApi.getAdminsWithActivity();
      setAdmins(response.data.data || []);
    } catch (error) {
      console.error('Failed to load admins:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'Never';
    return new Date(date).toLocaleString();
  };

  const getRoleBadgeColor = (roleName) => {
    switch (roleName) {
      case 'admin':
        return 'bg-blue-100 text-blue-800';
      case 'basic':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const columns = [
    {
      key: 'name',
      label: 'Admin',
      render: (row) => (
        <div>
          <div className="font-medium text-gray-900">{row.name}</div>
          <div className="text-sm text-gray-500">{row.email}</div>
        </div>
      )
    },
    {
      key: 'role',
      label: 'Role',
      render: (row) => (
        <span className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${getRoleBadgeColor(row.role?.name)}`}>
          {row.role?.name || 'Unknown'}
        </span>
      )
    },
    {
      key: 'lastLogin',
      label: 'Last Login',
      render: (row) => (
        <span className="text-sm text-gray-500">{formatDate(row.lastLogin)}</span>
      )
    },
    {
      key: 'mostVisitedPage',
      label: 'Most Visited Page',
      render: (row) => (
        <span className="text-sm text-gray-600">
          {row.mostVisitedPage || '-'}
        </span>
      )
    },
    {
      key: 'totalActivities',
      label: 'Total Activities',
      render: (row) => (
        <span className="text-sm font-medium text-gray-900">
          {row.totalActivities?.toLocaleString() || 0}
        </span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      align: 'right',
      render: (row) => (
        <div className="flex gap-2 justify-end">
          <button
            onClick={() => navigate(`/activity/${row._id}`)}
            className="text-primary-600 hover:text-primary-900 text-sm font-medium"
          >
            View Activity
          </button>
        </div>
      )
    }
  ];

  return (
    <DashboardLayout title="Activity Log">
      <div className="mb-6">
        <p className="text-gray-600">
          View and monitor activity for admin and basic users. Click on an admin to see their detailed activity history.
        </p>
      </div>

      <DataTable
        columns={columns}
        data={admins}
        loading={loading}
        emptyMessage="No admins found"
        onRowClick={(row) => navigate(`/activity/${row._id}`)}
      />
    </DashboardLayout>
  );
}
